import Web from "../../../Assets/icons/services/website.png";
import WebD from "../../../Assets/icons/services/website_d.png";
import App from "../../../Assets/icons/services/app.png";
import AppD from "../../../Assets/icons/services/app_d.png";
import GraphicDesign from "../../../Assets/icons/services/graphicDes.png";
import GraphicDesignD from "../../../Assets/icons/services/graphDes_d.png";
import SocialMedia from "../../../Assets/icons/services/social-media .png";
import SocialMediaD from "../../../Assets/icons/services/social-media_d.png";
import VideoEditing from "../../../Assets/icons/services/video-editing.png";
import VideoEditingD from "../../../Assets/icons/services/video-editing_d.png";
import ContentWriting from "../../../Assets/icons/services/copy-writing.png";
import ContentWritingD from "../../../Assets/icons/services/copy-writing_d.png";


export const ServicesData = [
    {
        id: 0,
        name: "Web Development",
        desc: "We weave the web of tomorrow, intuitive, innovative, and robust full-stack websites.",
        icon: Web,
        darkIcon: WebD,
    },
    {
        id: 1,
        name: "App Development",
        desc: "We craft pocket-sized powerhouse – where functionality meets finesse for both Android and iOS.",
        icon: App,
        darkIcon: AppD,
    },
    {
        id: 2,
        name: "Graphic Designing",
        desc: "Our Graphic designs that grip – striking designs that capture attention and convey your  message.",
        icon: GraphicDesign,
        darkIcon: GraphicDesignD,
    },
    {
        id: 3,
        name: "Digital Marketing",
        desc: "Digital dominance – your brand, our battlefield. Grow your brand with smart and effective online marketing",
        icon: SocialMedia,
        darkIcon: SocialMediaD,
    },
    {
        id: 4,
        name: "Video Editing",
        desc: "Visions edited to perfection by our experts – where every frame tells a story.",
        icon: VideoEditing,
        darkIcon: VideoEditingD,
    },
    {
        id: 5,
        name: "Content writing",
        desc: "We provide flexible content to fulfil your needs.",
        icon: ContentWriting,
        darkIcon: ContentWritingD,
    },
]